import request from '@/utilities/request';
import { countDown } from '@/utilities/index';

export default {
  async sendOTPCode({ commit, state, rootState }, reqBody) {
    commit('setIsCodeSentFail', false);

    window.clearInterval(state.counter);
    commit('setCounter', null);
    commit('setIsCountDowning', true);
    commit('setCoundownSec', 120);

    let counter;

    let recaptchaToken = '';
    let siteKey = '';

    try {
      const recaptchaResult = await state.recaptcha.execute('sendOTPCode');
      recaptchaToken = recaptchaResult.token;
      siteKey = recaptchaResult.siteKey;
    } catch (error) {
      // ignore
    }

    request
      .post('/signin/module.php/tmauth/passwordlesssendcode', {
        recaptchaToken,
        siteKey,
        ...reqBody,
        locale: rootState.userLang,
      })
      .then(() => {
        counter = countDown(
          120,
          (sec) => {
            commit('setCoundownSec', sec);
          },
          () => {
            commit('setIsCountDowning', false);
          },
        );

        commit('setCounter', counter);
        if (reqBody.email) {
          sessionStorage.setItem('emailOtpTime', new Date().getTime());
        }
      })
      .catch((err) => {
        if (reqBody.email && err?.response?.status === 409) {
          const cur = new Date().getTime();
          const sentTime = sessionStorage.getItem('emailOtpTime');
          if (!sentTime) {
            counter = countDown(
              120,
              (sec) => {
                commit('setCoundownSec', sec);
              },
              () => {
                commit('setIsCountDowning', false);
              },
            );

            sessionStorage.setItem('emailOtpTime', new Date().getTime());
            return;
          }

          const diff = (cur - sentTime) / 1000;
          if (diff > 0 && diff <= 120) {
            counter = countDown(
              Math.ceil(120 - diff),
              (sec) => {
                commit('setCoundownSec', sec);
              },
              () => {
                commit('setIsCountDowning', false);
              },
            );
          } else {
            commit('setIsCountDowning', false);
            commit('setIsCodeSentFail', true);
          }
        } else {
          commit('setIsCountDowning', false);
          commit('setIsCodeSentFail', true);
        }
      });
  },
  async verifyOTPCode({ commit, dispatch, state, rootState }, { reqBody }) {
    commit('setIsVerifying', true);
    commit('setOTPCodeErrorMsg', '');

    let recaptchaToken = '';
    let siteKey = '';

    try {
      const recaptchaResult = await state.recaptcha.execute('verifyOTPCode');
      recaptchaToken = recaptchaResult.token;
      siteKey = recaptchaResult.siteKey;
    } catch (error) {
      // ignore
    }

    return request
      .post('/signin/module.php/tmauth/passwordlessverifycode', {
        recaptchaToken,
        siteKey,
        ...reqBody,
      })
      .then(() => {
        commit('setIsVerifying', false);
        commit('setSignUpStep', 3);
        window.clearInterval(state.counter);
        commit('setCounter', null);
        dispatch('triggerEvent', { eventName: `VerifyOTPCodeSuccess` }, { root: true });
      })
      .catch((err) => {
        commit('setIsVerifying', false);
        if (err.response.status === 403) {
          commit('setOTPCodeErrorMsg', state.lang.incorrectCode);
        } else {
          commit('setOTPCodeErrorMsg', rootState.lang.error_msg.common);
        }

        dispatch(
          'triggerEvent',
          {
            eventName: `VerifyOTPCodeNG`,
            addInfo: {
              http_code: err?.response?.status,
            },
          },
          { root: true },
        );

        // Re-throw the error so callers can handle it
        throw err;
      });
  },
};
